import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import TransparentNavbar from './components/TransparentNavbar';
import Footer from './components/Footer';
import InstallPrompt from './components/InstallPrompt';
import Home from './home';
import MonCompte from './components/MonCompte';
import withAuth from './withAuth';
import Login from './login';
import NotFound from './components/NotFound';
import ErrorBoundary from './components/ErrorBoundary';
import useGridMetrics from './useGridMetrics';
import './App.css'

// Créés une seule fois (hors du rendu) pour éviter tout remontage.
const AuthenticatedHome = withAuth(Home);
const AuthenticatedMonCompte = withAuth(MonCompte);

function Shell() {
    const location = useLocation();
    const hideNav = location.pathname === '/login';

    return (
        <>
            {!hideNav && <TransparentNavbar />}
            <main className="bb-main">
                <ErrorBoundary>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/mon-compte" element={<AuthenticatedMonCompte />} />
                        <Route path="/" element={<Navigate to="/films" replace />} />
                        <Route path="/:mode" element={<AuthenticatedHome />} />
                        <Route path="/:mode/:id" element={<AuthenticatedHome />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </ErrorBoundary>
            </main>
            {!hideNav && <Footer />}
            <InstallPrompt />
        </>
    );
}

function App() {
    useGridMetrics();

    return (
        <div className="App">
            <Router>
                <Shell />
            </Router>
        </div>
    );
}

export default App;
